/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GeneralParameter } from '../models/general-parameter';
import { getGeneralParameter } from '../fn/general-parameters/get-general-parameter';
import { GetGeneralParameter$Params } from '../fn/general-parameters/get-general-parameter';
import { updateGeneralParameter } from '../fn/general-parameters/update-general-parameter';
import { UpdateGeneralParameter$Params } from '../fn/general-parameters/update-general-parameter';


/**
 * All about the general configuration parameters
 */
@Injectable({ providedIn: 'root' })
export class GeneralParametersService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getGeneralParameter()` */
  static readonly GetGeneralParameterPath = '/custom/parameters/{key}';

  /**
   * Get the current value of a general parameter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGeneralParameter()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGeneralParameter$Response(params: GetGeneralParameter$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralParameter>> {
    return getGeneralParameter(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the current value of a general parameter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGeneralParameter$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGeneralParameter(params: GetGeneralParameter$Params, context?: HttpContext): Observable<GeneralParameter> {
    return this.getGeneralParameter$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralParameter>): GeneralParameter => r.body)
    );
  }

  /** Path part for operation `updateGeneralParameter()` */
  static readonly UpdateGeneralParameterPath = '/custom/parameters/{key}';

  /**
   * Update the value of a general parameter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateGeneralParameter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGeneralParameter$Response(params: UpdateGeneralParameter$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateGeneralParameter(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the value of a general parameter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateGeneralParameter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGeneralParameter(params: UpdateGeneralParameter$Params, context?: HttpContext): Observable<void> {
    return this.updateGeneralParameter$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
